@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.catalystInsightWrapper {
  width: fit-content;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  @include border-radius-r2;
}

.companyCatalyst {
  background-color: var(--surface-decorative-lime-default);
}

.marketCatalyst {
  background-color: var(--surface-decorative-cyan-default);
}

.clickable {
  &:hover {
    transform: scale(1.05);
    cursor: pointer;
  }
}

.catalystInsightLabel {
  @include typography-v2-ui-xs;
  font-family: var(--font-nort);
}

.companyCatalystLabel {
  color: var(--text-decorative-lime);
}

.marketCatalystLabel {
  color: var(--text-decorative-cyan);
}
